/**
 * @flow
 * @relayHash 5833c62063cd03a7f75b088ed811c298
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContractTemplateContainer_node$ref = any;
type ContractTemplateContainer_viewer$ref = any;
export type TemplateRoutes_ContractTemplate_QueryVariables = {|
  id: string
|};
export type TemplateRoutes_ContractTemplate_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: ContractTemplateContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: ContractTemplateContainer_viewer$ref
  |},
|};
export type TemplateRoutes_ContractTemplate_Query = {|
  variables: TemplateRoutes_ContractTemplate_QueryVariables,
  response: TemplateRoutes_ContractTemplate_QueryResponse,
|};
*/


/*
query TemplateRoutes_ContractTemplate_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...ContractTemplateContainer_node
    id
  }
  viewer {
    ...ContractTemplateContainer_viewer
    id
  }
}

fragment ContractTemplateContainer_node on CTemplate {
  id
  title
  terms
  brand {
    id
    logo_url
    header
  }
  c_template_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  c_template_signature_blocks(first: 99999) {
    edges {
      node {
        id
        address_visibility
        company_name_visibility
        email_visibility
        name_visibility
        phone_visibility
        signing_party
        title_visibility
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ContractTemplateContainer_viewer on User {
  id
  first_name
  last_name
  primary_brand {
    id
  }
  ...SearchContainer_viewer
  ...LibraryContainer_viewer
}

fragment SearchContainer_viewer on User {
  s_time_zone
  user_event_search(first: 3, query: "") {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 1) {
          edges {
            node {
              location
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment LibraryContainer_viewer on User {
  id
  user_line_items(first: 99999) {
    edges {
      node {
        id
        description
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price_cents",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price_currency",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "TemplateRoutes_ContractTemplate_Query",
  "id": null,
  "text": "query TemplateRoutes_ContractTemplate_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ContractTemplateContainer_node\n    id\n  }\n  viewer {\n    ...ContractTemplateContainer_viewer\n    id\n  }\n}\n\nfragment ContractTemplateContainer_node on CTemplate {\n  id\n  title\n  terms\n  brand {\n    id\n    logo_url\n    header\n  }\n  c_template_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  c_template_signature_blocks(first: 99999) {\n    edges {\n      node {\n        id\n        address_visibility\n        company_name_visibility\n        email_visibility\n        name_visibility\n        phone_visibility\n        signing_party\n        title_visibility\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ContractTemplateContainer_viewer on User {\n  id\n  first_name\n  last_name\n  primary_brand {\n    id\n  }\n  ...SearchContainer_viewer\n  ...LibraryContainer_viewer\n}\n\nfragment SearchContainer_viewer on User {\n  s_time_zone\n  user_event_search(first: 3, query: \"\") {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 1) {\n          edges {\n            node {\n              location\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment LibraryContainer_viewer on User {\n  id\n  user_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TemplateRoutes_ContractTemplate_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContractTemplateContainer_node",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContractTemplateContainer_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TemplateRoutes_ContractTemplate_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "InlineFragment",
            "type": "CTemplate",
            "selections": [
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "terms",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "brand",
                "storageKey": null,
                "args": null,
                "concreteType": "Brand",
                "plural": false,
                "selections": [
                  v3,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "logo_url",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "header",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "c_template_line_items",
                "storageKey": "c_template_line_items(first:99999)",
                "args": v5,
                "concreteType": "CTemplateLineItemConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CTemplateLineItemEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CTemplateLineItem",
                        "plural": false,
                        "selections": [
                          v3,
                          v6,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "position",
                            "args": null,
                            "storageKey": null
                          },
                          v7,
                          v8,
                          v9,
                          v4,
                          v2
                        ]
                      },
                      v10
                    ]
                  },
                  v11
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "c_template_line_items",
                "args": v5,
                "handle": "connection",
                "key": "ContractTemplateContainer_c_template_line_items",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "c_template_signature_blocks",
                "storageKey": "c_template_signature_blocks(first:99999)",
                "args": v5,
                "concreteType": "CTemplateSignatureBlockConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CTemplateSignatureBlockEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CTemplateSignatureBlock",
                        "plural": false,
                        "selections": [
                          v3,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "address_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "company_name_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "phone_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "signing_party",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title_visibility",
                            "args": null,
                            "storageKey": null
                          },
                          v2
                        ]
                      },
                      v10
                    ]
                  },
                  v11
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "c_template_signature_blocks",
                "args": v5,
                "handle": "connection",
                "key": "ContractTemplateContainer_c_template_signature_blocks",
                "filters": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v3,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "last_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "primary_brand",
            "storageKey": null,
            "args": null,
            "concreteType": "Brand",
            "plural": false,
            "selections": [
              v3
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_search",
            "storageKey": "user_event_search(first:3,query:\"\")",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 3,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "query",
                "value": "",
                "type": "String!"
              }
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEvent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [
                          v3,
                          v4
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "booking_status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "start_at",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "end_at",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_event_segments",
                        "storageKey": "user_event_segments(first:1)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1,
                            "type": "Int"
                          }
                        ],
                        "concreteType": "UserEventSegmentConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserEventSegmentEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserEventSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "location",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v3
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v3
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_line_items",
            "storageKey": "user_line_items(first:99999)",
            "args": v5,
            "concreteType": "UserLineItemConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserLineItemEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserLineItem",
                    "plural": false,
                    "selections": [
                      v3,
                      v6,
                      v7,
                      v8,
                      v9,
                      v4,
                      v2
                    ]
                  },
                  v10
                ]
              },
              v11
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "user_line_items",
            "args": v5,
            "handle": "connection",
            "key": "LibraryContainer_user_line_items",
            "filters": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e82ae64885d914cce0576be8c4860225';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/TemplateRoutes_ContractTemplate_Query.graphql.js